var FileSaver = require('file-saver')

let converFile = function(name, blob) {
  blob = new Blob([blob], {
    type: 'application/octet-stream'
  })
  FileSaver.saveAs(blob, name)
  // let userAgent = navigator.userAgent
  // if (
  //   userAgent.indexOf('Chrome') > -1 ||
  //   userAgent.indexOf('Safari') > -1 ||
  //   userAgent.indexOf('Firefox') > -1
  // ) {
  //   const link = document.createElement('a')
  //   link.href = URL.createObjectURL(blob)
  //   link.setAttribute('download', name)
  //   if (typeof link.download === 'undefined') {
  //     link.setAttribute('target', '_blank')
  //   }
  //   link.click()

  //   setTimeout(() => {
  //     URL.revokeObjectURL(link.href)
  //   }, 1000)
  // } else {
  //   navigator.msSaveOrOpenBlob(blob, name)
  // }
}

let secondFormat = function(num) {
  if (!num) return [0, 0, 0, 0]
  let day = Math.floor(num / 86400)
  let hour = Math.floor((num - day * 86400) / 3600)
  let minute = Math.floor((num - day * 86400 - hour * 3600) / 60)
  let second = num - day * 86400 - hour * 3600 - minute * 60
  return [day, hour, minute, second]
}

export { converFile, secondFormat }
